import { SelectOption } from 'types/common/select';
import {
  ConnectAchievementBadge,
  ConnectCommunityUserType,
  ConnectInitObjectProps,
  ConnectUserStatus,
  ConnectUserSupplierType,
  ConnectUserType,
  UserStatus,
} from 'types/member';

export const connectStatusLabel = {
  [ConnectUserStatus.ACTIVE]: 'Active',
  [ConnectUserStatus.INACTIVE]: 'Inactive',
};

export const CONNECT_ABUSING_PAYMENT = 'payment';
export const CONNECT_ABUSING_COMMUNITY = 'community';

export const CONNECT_ABUSING_USER = [
  { label: 'Payment', value: CONNECT_ABUSING_PAYMENT },
  { label: 'Community', value: CONNECT_ABUSING_COMMUNITY },
];

export const CONNECT_ACHIEVEMENT_BADGE: SelectOption<ConnectAchievementBadge>[] = [
  { label: 'Community Hero', value: ConnectAchievementBadge.COMMUNITY_HERO },
  { label: 'CONNECT Supporters', value: ConnectAchievementBadge.CONNECT_SUPPORTERS },
  { label: 'Gamewear Creator', value: ConnectAchievementBadge.GAMEWEAR_CREATOR },
];

export const connectStatusOption: SelectOption[] = [
  {
    label: connectStatusLabel[ConnectUserStatus.ACTIVE],
    value: ConnectUserStatus.ACTIVE,
  },
  {
    label: connectStatusLabel[ConnectUserStatus.INACTIVE],
    value: ConnectUserStatus.INACTIVE,
  },
];

export const userStatusOption: SelectOption<UserStatus>[] = [
  {
    label: 'Active',
    value: UserStatus.ACTIVE,
  },
  {
    label: 'Inactive',
    value: UserStatus.INACTIVE,
  },
];

export const connectUserTypeOption: SelectOption<ConnectUserType>[] = [
  {
    label: 'General',
    value: ConnectUserType.GENERAL,
  },
  {
    label: 'Official',
    value: ConnectUserType.OFFICIAL,
  },
  {
    label: 'Supplier',
    value: ConnectUserType.SUPPLIER,
  },
  {
    label: 'CLO Creator Collective',
    value: ConnectUserType.CLO_CREATOR_COLLECTIVE,
  },
  {
    label: 'Next Gen Hub',
    value: ConnectUserType.NEXT_GEN_HUB,
  },
];

export const MAX_COUPON_RATE = 20;
export const MAX_COUPON_AMOUNT = 1000;

export enum CouponStatus {
  CANCELED = -1,
  USED,
  ISSUED,
}

export const couponStatusLabel = {
  [CouponStatus.CANCELED]: 'Canceled',
  [CouponStatus.USED]: 'Used',
  [CouponStatus.ISSUED]: 'Issued',
};

export enum CouponType {
  RATE = 1,
  PRICE = 2,
}

export const couponTypeOption: SelectOption<CouponType>[] = [
  {
    label: 'Price',
    value: CouponType.PRICE,
  },
  {
    label: 'Rate',
    value: CouponType.RATE,
  },
];

export const couponTypeLabel = {
  [CouponType.PRICE]: 'Price',
  [CouponType.RATE]: 'Rate',
};

export enum CouponReason {
  EVENT,
  REFERRAL,
  SURVEY,
  OTHER_REWARD,
}

export const couponReasonOption: SelectOption<CouponReason>[] = [
  {
    label: 'Event',
    value: CouponReason.EVENT,
  },
  {
    label: 'Referral',
    value: CouponReason.REFERRAL,
  },
  {
    label: 'Survey',
    value: CouponReason.SURVEY,
  },
  {
    label: 'Other Reward',
    value: CouponReason.OTHER_REWARD,
  },
];

export const couponReasonLabel = {
  [CouponReason.EVENT]: 'Event',
  [CouponReason.REFERRAL]: 'Referral',
  [CouponReason.SURVEY]: 'Survey',
  [CouponReason.OTHER_REWARD]: 'Other Reward',
};

export const connectUserSupplierTypes = [
  {
    label: 'Fabric',
    value: ConnectUserSupplierType.Fabric,
  },
  {
    label: 'Trim',
    value: ConnectUserSupplierType.Trim,
  },
];

export const connectCommunityUserTypeOption: SelectOption<ConnectCommunityUserType>[] = [
  {
    label: 'General',
    value: ConnectCommunityUserType.GENERAL,
  },
  {
    label: 'CLOver',
    value: ConnectCommunityUserType.CLOVER,
    divider: 'bottom',
  },
];

export const connectUserTypeLabel: Record<ConnectUserType, string> = {
  [ConnectUserType.GENERAL]: 'General',
  [ConnectUserType.SUPPLIER]: 'Supplier',
  [ConnectUserType.CLO_CREATOR_COLLECTIVE]: 'CLO Creator Collective',
  [ConnectUserType.OFFICIAL]: 'Official',
  [ConnectUserType.NEXT_GEN_HUB]: 'Next Gen Hub',
};

export const connectCommunityUserTypeLabel: Record<ConnectCommunityUserType, string> = {
  [ConnectCommunityUserType.GENERAL]: 'General',
  [ConnectCommunityUserType.CLOVER]: 'CLOver',
};

export const INITIAL_CLOSET_MEMBER_FILTER_VALUES: ConnectInitObjectProps = {
  userStatus: {
    [UserStatus.ACTIVE]: true,
    [UserStatus.INACTIVE]: true,
  },
};

// default 는 모두 선택 해제. 선택된 항목이 없으면 필터를 적용하지 않고 전체 값 조회
export const INITIAL_CONNECT_MEMBER_FILTER_VALUES: ConnectInitObjectProps = {
  connectAbusingUserStatus: {
    [CONNECT_ABUSING_PAYMENT]: false,
    [CONNECT_ABUSING_COMMUNITY]: false,
  },
  connectUserType: {
    [ConnectUserType.GENERAL]: false,
    [ConnectUserType.OFFICIAL]: false,
    [ConnectUserType.SUPPLIER]: false,
    [ConnectUserType.CLO_CREATOR_COLLECTIVE]: false,
    [ConnectUserType.NEXT_GEN_HUB]: false,
  },
  connectCommunityUserType: {
    [ConnectCommunityUserType.CLOVER]: false,
    [ConnectCommunityUserType.GENERAL]: false,
  },
  connectAchievementBadge: {
    [ConnectAchievementBadge.COMMUNITY_HERO]: false,
    [ConnectAchievementBadge.CONNECT_SUPPORTERS]: false,
    [ConnectAchievementBadge.GAMEWEAR_CREATOR]: false,
  },
};
